import { motion } from "framer-motion";
import { DoorOpen, Wrench, Recycle, Trash2 } from "lucide-react";

const extras = [
  { icon: DoorOpen, title: "Room of Choice", desc: "Safe, careful placement of items in the room the customer actually wants." },
  { icon: Wrench, title: "Assembly & Installation", desc: "Our crews assemble furniture and install relevant items with precision." },
  { icon: Recycle, title: "Packaging Removal", desc: "Eco-friendly removal and recycling of all packaging on the day." },
  { icon: Trash2, title: "Old Item Removal", desc: "We can take away and responsibly dispose of old items while delivering new ones." },
];

export const Extras = () => (
  <section id="extras" className="py-20 sm:py-24 bg-slate-50">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-blue-600 mb-4">Bolt-on options</p>
      <h2 className="text-4xl sm:text-5xl tracking-tight font-semibold text-slate-900 max-w-2xl">
        A little extra care, on request
      </h2>
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="extras-grid">
        {extras.map((s, i) => (
          <motion.div key={s.title} data-testid={`extra-card-${i}`}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="bg-white border border-slate-200 rounded-lg p-7 shadow-[0_2px_8px_rgba(15,23,42,0.04)] hover:shadow-[0_8px_24px_rgba(15,23,42,0.08)] hover:-translate-y-1 transition-all duration-300">
            <div className="w-12 h-12 rounded-lg bg-slate-900 flex items-center justify-center text-cyan-400 mb-5">
              <s.icon size={22} />
            </div>
            <h3 className="text-lg font-medium text-slate-900">{s.title}</h3>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
